export const addDomElement = (
  arr: { elemAttr: string; elemValue: string }[],
  element = 'meta',
  textNode: string | undefined = undefined
): void => {
  const elem = document.createElement(element);
  arr.forEach(metaTuple => {
    elem.setAttribute(metaTuple.elemAttr, metaTuple.elemValue);
  });

  if (textNode) {
    elem.textContent = textNode;
  }

  document.getElementsByTagName('head')[0]?.appendChild(elem);
};
